import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../src/assets/images/dustBox.svg'


const _withScopeId = n => (_pushScopeId("data-v-fa956b76"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "head-title" }, "写真追加画面")
], -1))
const _hoisted_2 = { class: "img-main" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "item-title" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "removeIcon"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Draggable = _resolveComponent("Draggable")!
  const _component_SelectFileButton = _resolveComponent("SelectFileButton")!
  const _component_SubmitButton = _resolveComponent("SubmitButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_Draggable, {
      list: _ctx.getReactiveImageData,
      "item-key": "id",
      onStart: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dragging = true)),
      onEnd: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dragging = false)),
      class: "main-display"
    }, {
      item: _withCtx(({ element }) => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            class: "image-view",
            src: element.url,
            alt: element.name
          }, null, 8, _hoisted_3),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(element.name), 1),
            _createElementVNode("a", {
              class: "remove-link",
              onClick: ($event: any) => (_ctx.removeItem(element))
            }, _hoisted_8, 8, _hoisted_6)
          ])
        ])
      ]),
      _: 1
    }, 8, ["list"]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_SelectFileButton, { onDispatchImage: _ctx.getImageData }, null, 8, ["onDispatchImage"]),
      _createVNode(_component_SubmitButton, {
        disable: _ctx.buttonDisable,
        getReactiveImageData: _ctx.getReactiveImageData
      }, null, 8, ["disable", "getReactiveImageData"])
    ])
  ], 64))
}